import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/school/dashboard'
const resource3 = '/api/v1/admin/school-details'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource3}/${uuid}`)
  },
}
